import firebase from 'firebase'
import dbConfig from '../../config/firebase.json'

if (firebase.apps.length === 0) {
  firebase.initializeApp(dbConfig)
}
export default firebase
